// =====================================================================
// MotDePasseOublie.jsx — page PUBLIQUE /mot-de-passe-oublie (23-10-2026)
// =====================================================================
// L'opérateur donne son identifiant ; le serveur répond toujours la même chose (pas moyen de savoir si un compte
// existe). Le lien part seulement pour un compte actif, sous contrat ce jour-là, avec une adresse e-mail.
// =====================================================================
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth, errMsg } from '../services/api.js';
import CarteMotDePasse, { styles } from '../components/CarteMotDePasse.jsx';

export default function MotDePasseOublie() {
  const [identifiant, setIdentifiant] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [reponse, setReponse] = useState(null);
  const [erreur, setErreur] = useState(null);

  async function envoyer(e) {
    e.preventDefault();
    if (!identifiant.trim()) return;
    setErreur(null);
    setEnvoi(true);
    try {
      const r = await auth.motDePasseOublie(identifiant.trim());
      setReponse(r.message);
    } catch (err) {
      setErreur(errMsg(err));
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <CarteMotDePasse titre="Mot de passe oublié">
      {reponse ? (
        <>
          <div style={{ ...styles.succes, marginTop: 20 }}>{reponse}</div>
          <Link to="/login" style={styles.lien}>← Retour à la connexion</Link>
        </>
      ) : (
        <>
          <p style={styles.texte}>
            Donnez votre identifiant Zeus (celui de la connexion). Vous recevrez par e-mail un lien pour choisir un
            nouveau mot de passe.
          </p>
          <form onSubmit={envoyer}>
            <div style={{ marginBottom: 18 }}>
              <label style={styles.label} htmlFor="identifiant">Identifiant</label>
              <input id="identifiant" type="text" required autoFocus autoComplete="username" value={identifiant}
                onChange={(e) => setIdentifiant(e.target.value)} style={styles.champ} maxLength={100} />
            </div>
            {erreur && <div style={styles.erreur}>{erreur}</div>}
            <button type="submit" disabled={envoi} style={styles.bouton(!envoi)}>
              {envoi ? 'Envoi…' : 'Recevoir le lien par e-mail'}
            </button>
          </form>
          <Link to="/login" style={styles.lien}>← Retour à la connexion</Link>
        </>
      )}
    </CarteMotDePasse>
  );
}
